export enum RespiAllerValueType {
    aanvullendOnderzoek = 'aanvullend onderzoek',
    conclusie = 'conclusie',
    dossiersamenvatting = 'dossiersamenvatting',
    icd10 = 'icd-10',
    individueleAanbevelingen = 'individuele aanbevelingen',
    medicamenteusAdvies = 'medicamenteus advies',
    negatieveUitslagen = 'negatieve uitslagen',
    nietMedicamenteusAdvies = 'niet-medicamenteus advies',
    opmerkingenVoorHuisarts = 'opmerkingen voor huisarts',
    positieveUitslagen = 'positieve uitslagen',
}
